module.exports = __webpack_public_path__ + "img/mortgage.c49004b.svg";